import React from 'react';

const nutrients = [['calories', 'Calories', 'kcal'], ['protein', 'Protein', 'g'], ['carbs', 'Carbs', 'g'], ['fat', 'Fat', 'g'], ['fiber', 'Fibre', 'g'], ['sugar', 'Sugar', 'g'], ['sodium', 'Sodium', 'mg']];

export default function DishNutrition({ item }) {
  const facts = nutrients.filter(([key]) => typeof item.nutritional_info?.[key] === 'number' && Number.isFinite(item.nutritional_info[key]) && item.nutritional_info[key] >= 0);
  return <div className="dish-nutrition" aria-label={`Nutrition for ${item.name}`}>
    <div className="dish-nutrition-basis">{facts.length ? (item.nutrition_serving_size || (item.default_unit ? `Per ${item.default_unit}` : 'Serving size not provided')) : 'Nutrition not provided yet'}</div>
    {!!facts.length && <dl>{facts.map(([key, label, unit]) => <div key={key}><dt>{label}</dt><dd>{item.nutritional_info[key]} {unit}</dd></div>)}</dl>}
  </div>;
}
